export default "__VITE_ASSET__DcsODzfk__"